import React, { memo, useMemo } from 'react'
import Slider from 'root/src/client/web/base/Slider'
import map from 'ramda/src/map'
import identity from 'ramda/src/identity'
import withStyles from '@material-ui/core/styles/withStyles'
import { useWindowSize } from 'root/src/client/v2/common/hooks/useWindowSize'
import dynamic from 'next/dynamic'
import { SliderCardsListStyle } from './style'

const cardListTypes = {
	projectCard: dynamic(() => import('root/src/client/web/list/listItemComponents/project/ProjectCard')),
	creatorCard: dynamic(() => import('root/src/client/web/list/listItemComponents/CreatorCard')),
}

const childrenLengthTypes = {
	projectCard: 8,
	creatorCard: 6,
}

const SliderCardsList = memo(({
	classes, list, isMobileRes, cardListType, scrollItemBreakpoints, sliderWidth,
}) => {
	const [width] = useWindowSize()
	const CardComponent = useMemo(() => cardListTypes[cardListType], [cardListType])
	const childrenLength = useMemo(() => (
		childrenLengthTypes[cardListType]
	), [cardListType])

	if (!CardComponent || typeof childrenLength !== 'number') {
		return <div>cardListType not supported</div>
	}

	const renderSliderItem = () => identity
	return (
		<div className={classes.root}>
			<div className={classes.sliderWrapper}>
				<Slider
					arrows
					infinite
					isMobileRes={isMobileRes}
					stepMultiplier={1.85}
					sliderWidth={sliderWidth(width)}
					sliderItems={list}
					dragActive={!isMobileRes}
					showItems={scrollItemBreakpoints(width)}
					renderSliderItem={renderSliderItem}
					childrenLength={childrenLength}
				>
					{map(recordId => (
						<CardComponent
							key={recordId}
							recordId={recordId}
						/>
					), list)}
				</Slider>
			</div>
		</div>
	)
})

export default withStyles(SliderCardsListStyle, { name: 'MuiSliderCardsList' })(SliderCardsList)
